/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import * as React from 'react'
import { CSSProperties, ReactElement } from 'react'

import { SideControlBar, theme } from '@lmc/ui-kit'
import { history } from '../../../../../../../../store'
import { Button } from '@lmc/ui-kit'
import { ConsentType } from '@lmc/common/types'

type ModalSideControlBarProps = {
  sideControlIds: string[]
  handleSelected: (id: string) => void
  translate: (key: string, variable?: any) => string
  customEntry?: () => void
  isMobile?: boolean
  consentType?: ConsentType
}

export const ModalSideControlBar = ({
  sideControlIds,
  translate,
  handleSelected,
  customEntry,
  isMobile,
  consentType = 'consent'
}: ModalSideControlBarProps): ReactElement => {
  const titleKey =
    consentType === 'lackOfCapacity'
      ? 'selectCapacityForm'
      : 'selectConsentForms'

  const toViewFormsKey =
    consentType === 'lackOfCapacity' ? 'toViewCapacityForms' : 'toViewForms'

  return (
    <SideControlBar
      isMobile={isMobile}
      list={sideControlIds}
      title={
        <div style={styles.title as CSSProperties}>{translate(titleKey)}</div>
      }
      subTitle={
        <div style={styles.subTitle as CSSProperties}>
          <strong
            style={styles.subTitleStrong}
            onClick={() => history.push('/settings/consent-templates')}
          >
            {translate('clickHere')}
          </strong>
          {` `}
          {translate(toViewFormsKey)}
        </div>
      }
      onChange={handleSelected}
    >
      <div style={styles.sideControlBar.container as CSSProperties}>
        <div style={styles.sideControlBar.title as CSSProperties}>
          {translate('cantSee')}{' '}
        </div>
        <Button
          style={styles.sideControlBar.buttonEntry}
          variant="primary"
          onClick={customEntry}
        >
          {translate('customEntry')}
        </Button>
      </div>
    </SideControlBar>
  )
}

const styles = {
  title: {
    textAlign: 'center',
    fontSize: 17,
    fontWeight: 700
    // opacity: 0.59,
  },
  subTitle: { textAlign: 'center', fontSize: 13, fontWeight: 300 },
  subTitleStrong: {
    fontWeight: 600,
    color: theme.color.status.primary,
    opacity: 1,
    cursor: 'pointer'
  },
  sideControlBar: {
    container: {
      display: 'flex',
      flexDirection: 'column'
    },
    title: { textAlign: 'center', fontWeight: 300, fontSize: 14 },
    buttonEntry: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 2
    },
    buttomComing: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 2
    }
  }
}

export default ModalSideControlBar
